import { defineMessages } from 'react-intl';

const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  partners: {
    id: '0kWA9C',
    defaultMessage: 'Партнерам'
  },
  toPartners: {
    id: '0kWA9C',
    defaultMessage: 'Партнерам'
  },
  Integration: {
    id: '0GCAUr',
    defaultMessage: 'Інтеграція'
  },
  aboutApi: {
    id: 'wuab8q',
    defaultMessage: 'Загальна інформація про API'
  },
  loadingPharmacies: {
    id: 't7cnIW',
    defaultMessage: 'API Завантаження аптек'
  },
  removalPharmacies: {
    id: 'u88iGQ',
    defaultMessage: 'Видалення аптек'
  },
  loadingRemainingProds: {
    id: 'XDJdlr',
    defaultMessage: 'API Завантаження даних про залишки товарів'
  },
  removalOfResidues: {
    id: 'w/x7Pj',
    defaultMessage: 'Видалення залишків'
  },
  orderStatus: {
    id: 'cl+a/N',
    defaultMessage: 'Статуси замовлення'
  },
  process: {
    id: 't9yzV8',
    defaultMessage: 'Бізнес процес'
  },
  changingDrugList: {
    id: '7mA7oG',
    defaultMessage: 'Зміна списку товарів'
  },
  creationOfTestReservation: {
    id: '/THIXa',
    defaultMessage: 'Створення тестового бронювання'
  },
  receivingNewBookings: {
    id: 'z9S0A/',
    defaultMessage: 'Отримання нових бронювань'
  },
  updateBookingStatus: {
    id: '5l7qj7',
    defaultMessage: 'Обновлення статусу бронювання'
  },
  check: {
    id: 'hBJsDk',
    defaultMessage: 'Як перевірити, що все працює'
  }
});

export default trns;
